// extracted by mini-css-extract-plugin
export default {"dateText":"DatePicker_dateText__JD0GJ","datePickerContainer":"DatePicker_datePickerContainer__MzG2X","dateBox":"DatePicker_dateBox__X8Kzh"};